import React from "react";
import values from "lodash/values";
import pick from "lodash/pickBy";
import { RaisedButton, TextField, FlatButton } from "material-ui";
import juration from "juration";

import connectToStores from "alt-utils/lib/connectToStores";
import VirtualContentStore from "../stores/VirtualContentStore";
import VirtualContentActions from "../actions/VirtualContentActions";
import Dropzone from "react-dropzone";

import config from "../config";
import UserStore from "../stores/UserStore";
import UserUtil from "../utils/UserUtil";
import { formatBytes } from "../util";

import WorkingIndicator from "./partials/working-indicator.jsx";
import LinkLike from "./partials/link-like.jsx";
import Label from "./partials/label.jsx";
import { Status } from "./partials/film-table.jsx";
import TableRefreshIndicator from "./partials/table-refresh-indicator.jsx";
import VirtualContentPreviewOverlay from "./partials/overlays/virtual-content-preview.jsx";

class VirtualContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      virtualContent: null,
      label: "",
      caption_tracks: [],
      dirty: false,
      showPreview: false
    };

    this._refresh = this._refresh.bind(this);
  }

  static getStores() {
    return [VirtualContentStore];
  }

  static getPropsFromStores() {
    return VirtualContentStore.getState();
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  save() {
    VirtualContentActions.edit(this.props.params.virtualContentId, {
      label: this.state.label,
      caption_tracks: this.state.caption_tracks.filter(c => !!c.url)
    });
  }

  getStyles() {
    return {
      container: {
        maxWidth: 500,
        margin: "5% auto",
        fontSize: "11pt",
        padding: "5px 20px 20px",
        borderRadius: "1em",
        boxShadow: "0 0 20px 2px rgba(0,0,0,0.2)"
      },
      actions: {
        marginTop: "1em"
      }
    };
  }

  componentWillMount() {
    VirtualContentActions.fetchOne.defer(this.props.params.virtualContentId);
    this.componentWillReceiveProps(this.props);
  }

  _refresh() {
    VirtualContentActions.fetchOne(this.props.params.virtualContentId);
  }

  componentWillReceiveProps(newProps) {
    const virtualContent =
      newProps.virtualContents[newProps.params.virtualContentId];
    if (
      virtualContent &&
      (!this.state.virtualContent ||
        (this.props.isEditing && newProps.isEditing) ||
        (this.props.isFetching && !newProps.isFetching) ||
        (virtualContent._is_limited_access &&
          !this.state.virtualContent._is_limited_access) ||
        this.state.virtualContent.status !== virtualContent.status)
    ) {
      this.setState({
        virtualContent,
        label: virtualContent.label,
        caption_tracks: virtualContent.caption_tracks,
        dirty: false
      });
    }
  }

  render() {
    let styles = this.getStyles(),
      { virtualContent } = this.state;

    if (!virtualContent) {
      return <WorkingIndicator fullPage={true} />;
    }

    return (
      <div>
        {this.props.isEditing && (
          <WorkingIndicator fullPage={true} overlay={true} />
        )}
        {this.state.showPreview ? (
          <VirtualContentPreviewOverlay
            virtualContentId={virtualContent.id}
            onRequestClose={() => this.setState({ showPreview: false })}
          />
        ) : null}
        <div style={styles.container}>
          <TableRefreshIndicator
            isRefreshing={this.props.isFetching}
            onRefresh={this._refresh}
            style={{ marginTop: "2.5%" }}
          />
          <TextField
            floatingLabelText="Content asset label"
            floatingLabelFixed={true}
            value={this.state.label}
            disabled={virtualContent._is_limited_access}
            onChange={e =>
              this.setState({ label: e.target.value, dirty: true })
            }
          />
          <Label style={{ marginTop: "0.5em", marginBottom: "0em" }}>
            Content asset status
          </Label>
          <Status virtual_content={virtualContent} />
          {virtualContent._fetched_at ? (
            <div
              style={{
                fontWeight: "bold",
                color: "rgba(0,0,0,0.4)",
                display: "block",
                fontSize: "0.7em",
                marginTop: "0.1em",
                lineHeight: "1.1em"
              }}
            >
              Last checked{" "}
              {new Date(virtualContent._fetched_at).toLocaleTimeString()}
            </div>
          ) : null}
          {virtualContent.duration ? (
            <div>
              <Label style={{ marginBottom: "0em" }}>
                Content asset duration
              </Label>
              <div>{juration.stringify(virtualContent.duration / 1000)}</div>
            </div>
          ) : null}
          <Label style={{ marginBottom: "0em" }}>Content asset preview</Label>
          <div style={{ color: "rgba(0,0,0,0.6)", fontStyle: "italic" }}>
            {virtualContent._is_limited_access ? (
              "Only available to original uploader"
            ) : virtualContent.status === "ready" ? (
              this.state.dirty ? (
                "Save changes to preview"
              ) : (
                <LinkLike
                  onTouchTap={() => this.setState({ showPreview: true })}
                  style={{ fontStyle: "normal" }}
                >
                  View preview
                </LinkLike>
              )
            ) : virtualContent.status.indexOf("pending_") === 0 ? (
              "Available when transcoding completed"
            ) : (
              "Not available"
            )}
          </div>
          <Label style={{ marginBottom: "0em" }}>Original file size</Label>
          <div>{formatBytes(virtualContent.file_size || 0)}</div>
          <Label style={{ marginBottom: "0em" }}>Subtitles</Label>
          <div>
            {this.state.caption_tracks.map((t, i) => (
              <div
                key={`${i}-${t.url}`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: -5,
                  marginBottom: 5
                }}
              >
                <TextField
                  placeholder="Subtitle track title"
                  style={{ width: 200 }}
                  value={this.state.caption_tracks[i].title}
                  onChange={e => {
                    this.state.caption_tracks[i].title = e.target.value;
                    this.setState({
                      caption_tracks: this.state.caption_tracks,
                      dirty: true
                    });
                  }}
                />
                <div style={{ marginLeft: 10 }}>
                  {t.url ? (
                    <div>
                      <RaisedButton disabled label="Uploaded" />
                    </div>
                  ) : t.uploading ? (
                    <div>
                      <RaisedButton disabled label="Uploading" />
                    </div>
                  ) : (
                    <Dropzone
                      style={{}}
                      onDrop={files => {
                        if (files.length) {
                          this.state.caption_tracks[i].uploading = true;
                          this.setState({
                            caption_tracks: this.state.caption_tracks
                          });

                          UserUtil.uploadFile(
                            UserStore.getState().apiKey,
                            `${virtualContent.id}-captions-${Date.now()}`,
                            files[0],
                            { transform: "captions" }
                          )
                            .then(data => {
                              this.state.caption_tracks[i].url = data.url;
                              this.setState({
                                caption_tracks: this.state.caption_tracks,
                                dirty: true
                              });
                            })
                            .catch(e => {
                              this.state.caption_tracks[i].url = undefined;
                              this.setState(
                                {
                                  caption_tracks: this.state.caption_tracks
                                },
                                () => {
                                  window.alert(`Upload failed: ${e.message}`);
                                }
                              );
                            });
                        }
                      }}
                    >
                      <RaisedButton primary label="Add file" />
                    </Dropzone>
                  )}
                </div>
                <div style={{ marginLeft: 10 }}>
                  <FlatButton
                    onClick={() => {
                      this.state.caption_tracks.splice(i, 1);
                      this.setState({
                        caption_tracks: this.state.caption_tracks,
                        dirty: true
                      });
                    }}
                    label={<span style={{ fontSize: "1.5em" }}>×</span>}
                  />
                </div>
              </div>
            ))}
            <div>
              {this.state.caption_tracks.length === 0 ? (
                <span>None &middot; </span>
              ) : null}
              <LinkLike
                onTouchTap={() => {
                  this.setState({
                    caption_tracks: this.state.caption_tracks.concat([
                      { title: "English" }
                    ])
                  });
                }}
              >
                Upload {this.state.caption_tracks.length ? "additional" : ""}{" "}
                subtitles
              </LinkLike>
              <div style={{ fontSize: "0.8em" }}>
                .srt, .vtt files supported
              </div>
            </div>
          </div>
          <div style={styles.actions}>
            <RaisedButton
              label="Save content asset"
              onClick={() => this.save()}
              disabled={!this.state.dirty}
              primary
            />
          </div>
          {!virtualContent._is_limited_access && (
            <div style={styles.actions}>
              <LinkLike
                onTouchTap={() =>
                  Intercom(
                    "showNewMessage",
                    `Please destroy the content asset ${virtualContent.label} (ref # ${virtualContent.id}).`
                  )
                }
              >
                Destroy content asset
              </LinkLike>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default connectToStores(VirtualContent);



// WEBPACK FOOTER //
// ./src/app/components/creator-virtual-content.jsx